/**
 * The purpose of this file is to provide an ordering for display fields in
 * every type of info window with display fields. Each key represents a type
 * of info window, and the arrays are ordered lists of keys that can be used
 * with fieldTypes.js and typeFormats.js to get more data about the
 * display field
 */


// standardFields
export default {
  /** --- SALESFORCE INFO WINDOWS --- */
  'industrialBuilding': [
    'address',
    'yearBuilt',
    'expectedTco',
    'totalAvailable',
    'buildingArea',
    'leasedPercentage',
    'buildingStage',
    'buildingWidth',
    'clearHeight',
    'entityName',
    'currentMlaRent',
    'taxBill',
    'brochure',
    'siteCamera',
    'schedule',
  ],
  'industrialBuildingLease': [
    'premiseArea',
    'leaseSigned',
    'commencementDate',
    'leaseExpiration',
    'startingRent',
    'rentAbatements',
    'leaseTerm',
    'rentEscalator',
    'vacateDate',
  ],
  'industrialBuildingActive Lease Deal': [
    'latestBaseRent',
    'latestPremiseArea',
    'rfpStage',
    'requirementArea',
    'submitted',
  ],
  'industrialBuildingCapital': [
    'investmentStage',
    'debtStatus',
    'primaryInvestor',
    'loanType',
    'lender',
    'closingDate',
    'totalCapitalAuthorized',
    'cashEquity',
    'transactionValue',
    'commencementDate',
    'maturityDate',
    'loanAmount',
    'interestRate',
    'rateType',
    'reference',
    'debtAmortization',
    'debtTerms',
  ],

  /** --- FIRESTORE INFO WINDOWS --- */
  'competitiveBuilding': [
    'address',
    'buildingSize',
    'clearHeight',
    'county',
    'developer',
    'listingBroker',
    'owner',
    'buildingStage',
    'buildingType',
    'yearBuilt',
    'constructionCompletionDate',
    'totalAvailable',
    'leasedPercentage',
    'lastModifiedBy',
  ],
  'competitiveBuildingLease': [
    'premiseArea',
    'leaseType',
    'term',
    'baseRent',
    'effectiveRent',
    'annualEscalations',
    'tiPerSf',
    'freeRent',
    'officeFinish',
    'landlord',
    'startDate',
    'signDate',
    'source',
    'expirationDate',
    'currentRent',
  ],
  'multiFamilyBuilding': [
    'address',
    'yearBuilt',
    'unitCount',
    'averageSize',
    'marketRentPSF',
    'percentOccupied',
    'lastModifiedBy',
  ],
  'dataCenterBuilding': [
    'plantId',
    'plantName',
    'parentName',
    'ownerName',
    'capacity',
    'squareFootage',
    'dcStatus',
    'isoRTORegion',
    'plantStartUpDate',
    'projectCount',
    'constructionDurationWithCounts',
    'tivUSDWithCounts',
    'projectTypeWithCounts',
    'projectStageWithCounts',
    'kickoffDateWithCounts',
    'completionDateWithCounts',
    'hyperScalerFlag',
    'lastModifiedBy',
  ],
  'competitiveBuildingLand Sale': [
    'buyer',
    'seller',
    'buildingSf',
    'acreage',
    'salePrice',
    'saleDate',
    'pricePerAcre',
    'pricePerSf',
    'pricePerFar',
    'source',
  ],
  'competitiveBuildingBuilding Sale': [
    'buyer',
    'seller',
    'areaSold',
    'buildingCount',
    'salePrice',
    'pricePerSf',
    'saleDate',
    'capRate',
    'occupancy',
    'walt',
    'source',
  ],
  'competitivePortfolio': [
    'buyer',
    'seller',
    'totalBuildingArea',
    'buildingCount',
    'yearBuilt',
    'occupancy',
    'walt',
    'saleDate',
    'salePrice',
    'pricePerSf',
    'goingInCapRate',
    'weightedAvgMarketRent',
    'weightedAvgOmRent',
    'mtmOpportunity',
    'lastModifiedBy',
  ],
  /** PARCEL INFO WINDOWS */
  'itamlinkTaxParcel': [
    'propertyName',
    'parcelNumber',
    'parcelNumber2',
    'parcelGrossBuildingArea',
    'parcelLandArea',
    'propertyAddress',
    'propertyCounty',
    'parcelAddress',
    'parcelCounty',
  ],
  'parcel': [
    'parcelId',
    'owner',
    'address',
    'county',
    'lastUpdated',
    'mailingAddress',
    'acreageWithSameOwner',
    'ownerOccupied',
    'saleDate',
    'salePrice',
    'marketLandValue',
    'marketBuildingValue',
    'marketTotalValue',
    'buildingSf',
    'numberFloors',
    'numberBuildings',
    'neighborhoodCode',
    'landUseCode',
    'landUseClass',
    'uspsClassification',
    'legalDescription',
    'elevation',
    'acreageDeeded',
    'acreageCalculated',
    'websiteLink',
    'robustId',
    'townshipRange',
  ],
  /** LAYER INFO WINDOWS */
  'Labor Cost': [],
  'Labor Pool': [],
  'Labor Score': [],
  'Electric Power Transmission Lines': [
    'naicsDesc',
    'transmissionLineOwner',
    'sourceDate',
    'status',
    'sub1',
    'sub2',
    'type',
    'voltage',
  ],
  'Electric Retail Service Territories': [
    'territoryName',
    'territoryAddress',
    'territoryCity',
    'territoryState',
    'territoryZip',
    'territoryPhone',
    'territoryType',
    'website',
    'regulated',
    'centralArea',
    'planArea',
    'holdingCompany',
    'summerPeak',
    'winterPeak',
    'summerCap',
    'winterCap',
    'netGen',
    'purchased',
    'netEx',
    'retailMWH',
    'wSaleMWH',
    'totalMWH',
    'transMWH',
    'customers',
  ],
  'SoCal Edison Network': [
    'substationId',
    'substationName',
    'systemName',
    'substationType',
    'substationVoltage',
    'existingGen',
    'queuedGen',
    'totalGen',
    'projectedLoad',
    'penetrationLevel',
    'maxRemainCap',
    'note',
    'circuitId',
    'circuitNo',
    'circuitTypeDesc',
    'circuitVoltage',
    'circuitType',
    'circuitName',
  ],
  'Electric Power Generation Plants': [
    'plantStat',
    'county',
    'sector',
    'nameplateCapacity',
    'techType',
    'generatorIds',
    'entityName',
    'status',
  ],
  'Power (OpenStreetMap)': [
    'name',
    'circuits',
    'voltage',
    'operator',
    'method',
    'output',
    'source',
    'voltageTwo',
    'startDate',
    'type',
    'electrical_output',
  ],
  'Water (OpenStreetMap)': [
    'name',
    'location',
    'operator',
    'substance',
    'usage',
    'diameter',
  ],
  'Oil & Gas (OpenStreetMap)': [
    'name',
    'location',
    'operator',
    'ref',
    'substance',
    'usage',
    'startDate',
    'diameter',
  ],
  'Nonattainment Areas & Designations': [
    'area_name',
    'daa_proposed_citation',
    'cdd_proposed_pub_date',
    'cdd_final_citation',
    'daa_effective_date',
    'original_dv24',
    'designation_effective_date',
    'daa_final_pub_date',
    'populationtotals_totpop_cy',
    'redesignation_effective_date',
    'epa_region_office',
    'state_name',
    'designation_pub_date',
    'populationtotalspl94_totpop20',
    'redesignation_final_pub_date',
    'meets_naaqs',
    'redesignation_proposed_url',
    'classification_pub_date',
    'redesignation_proposed_pub_dat',
    'composidplus',
    'classification',
    'designation_url',
    'daa_final_citation',
    'designation_citation',
    'composite_id',
    'daa_final_url',
    'epa_region_roman',
    'current_status',
    'population_2010',
    'redesignation_proposed_citatio',
    'classification_effective_date',
    'classification_citation',
    'daa_proposed_url',
    'composid',
    'epa_region',
    'state_abbreviation',
    'design_value',
    'cdd_final_url',
    'statutory_attainment_date',
    'composite_id_with_state',
    'state_suffix',
    'dv_units',
    'classification_url',
    'dv_years',
    'redesignation_final_citation',
    'cdd_effective_date',
    'original_dv_years',
    'daa_proposed_pub_date',
    'projected_redesignation_date',
    'cdd_final_pub_date',
    'cdd_proposed_citation',
    'fips_state',
    'pollutant_name',
    'dv24',
    'cdd_proposed_url',
    'original_design_value',
    'redesignation_final_url',
    'location',
  ],
  'NPD Pipeline': [
    'submarket_',
    'market',
    'esriField',
    'lead',
    'mar_inv',
    'npd_inv',
    'npd_vac',
    'npd_vacp',
    'npd_shar',
    'mar_vac',
    'mar_aban',
    'mar_ab5',
    'pipNon12',
    'pipNon24',
    'pipBul12',
    'pipBul24',
    'pipTot12',
    'pipTot24',
    'bal12',
    'bal24',
  ],
  'Drayage': [
    'popup',
    'rateDataDa',
  ],
  'Insurance Hazards': [
    'hazard_typ',
  ],
  'Industrial Markets and Submarkets': [
    'period',
    'acquisitionsRanking',
    'marketMomentumIndex',
    'rankingDescription',
    'totalInventory',
    'delivered',
    'vacancyQuarter',
    'vacancyHistoric10Yr',
    'netAbsorptionQuarter',
    'netAbsorptionRolling12Mth',
    'netAbsorption10Yr',
    'underConstructionQuarter',
    'underConstructionRolling12Mth',
    'rentQuarter',
    'rentRolling12MthAvg',
    'rentRolling12MthPctChange',
    'leasingActivityQuarter',
    'newBldgsAvgSize5Yr',
    'newBldgsCount5Yr',
    'supplyDemandImbalanceScore',
    'recoveryPotentialMetric',
    'absorptionConstructionInteraction',
    'absorptionVacancyInteraction',
    'constructionLeasingRisk',
  ],
  'MF Market and Submarket': [
    'period',
    'rankid',
    'year',
    'rankdescrp',
    'slice',
    'totpopuln',
    'medhhincm',
    'absorpunit',
    'assetvalue',
    'classainvu',
    'classbinvu',
    'totsubinv',
    'pctclassa',
    'pctclassb',
    'underconst',
    'startunits',
    'netdelivu',
    'stabvacnc',
    'effrentpu',
    'caprate',
    'rent4qchg',
    'pop4qchg',
    'uc8qave',
    'abs4qsum',
    'nd4qsum',
    'roll4qrchg',
    'roll4qpchg',
    'abs4qpcti',
    'rentpctinc',
  ],
  'Flood Hazard Zones': [],
  'Wetlands': [
    'acres',
    'qaqc_code',
  ],
  'Railroads': [
    'railName',
    'railOwner',
    'jointOwners',
    'trackRights',
  ],
  'Counties and Municipalities': [
    'layerType',
  ],
  'Power Offtake Capacity': [
    'pocModelPublishDate',
    'pocLGSubName',
    'pocOpenInfraSubName',
    'pocNRISMinOfftakeCapacity',
    'pocNRISMaxOfftakeCapacity',
    'pocMinVoltage',
    'pocMaxVoltage',
    'pocOperator',
    'pocStatus',
    'pocLandGateId',
    'pocLGType',
    'ppssLines',
    'pocRecordId',
  ],
  'Power Plants & Substations': [
    'ppssStreetAddress',
    'ppssCity',
    'ppssState',
    'ppssZip',
    'ppssType',
    'ppssStatus',
    'ppssCounty',
    'ppssCountyFips',
    'ppssCountry',
    'ppssLines',
    'ppssMaxVoltage',
    'ppssMinVoltage',
    'ppssLatitude',
    'ppssLongitude',
    'ppssElectricLoadZone',
    'ppssTransLines',
    'ppssSubtransLines',
    'ppssDistLines',
    'ppssPlantCode',
    'ppssPlantName',
    'ppssOperatorName',
    'ppssUtilityId',
    'ppssUtilityName',
    'ppssNercRegion',
    'ppssBalancingAuthorityCode',
    'ppssBalancingAuthorityName',
    'ppssSector',
    'ppssSectorName',
    'ppssTransOrDistSystemOwner',
    'ppssTransOrDistSystemOwnerId',
    'ppssEnergyStorage',
    'ppssNameplateCapacity',
    'ppssCapacityOperating',
    'ppssCapacityBuildings',
    'ppssCapacityPlanned',
    'ppssCapacityMw',
    'ppssPowerFactor',
    'ppssProdStart',
    'ppssFuelPrimary',
    'ppssFuelSecondary',
    'ppssPrimSource',
    'ppssTechnology',
    'ppssOperator',
  ],
  'Transmission Lines (kV)': [
    'lgTransLinesCounty',
    'lgTransLinesState',
    'lgTransLinesOwner',
    'lgTransLinesType',
    'lgTransLinesStatus',
    'lgTransLinesVoltage',
    'lgTransLinesSub1',
    'lgTransLinesSub2',
    'lgTransLinesAmperage',
    'lgTransLinesMaxCapacity',
  ],
  'Distribution Lines': [
    'lgDistributionCircuitName',
    'lgDistributionCounty',
    'lgDistributionPeakAmps',
    'lgDistributionSummerRating',
    'lgDistributionFilterPhase',
    'lgDistributionLineName',
    'lgDistributionState',
    'lgDistributionPhases',
    'lgDistributionOwner',
    'lgDistributionPhase',
    'lgDistributionCapacityLimit',
    'lgDistributionOverUnder',
    'lgDistributionVoltage',
    'lgDistributionHostingCapacity',
    'lgDistributionLoadZone',
    'lgDistributionLoadSubZone',
    'lgDistributionSub1',
    'lgDistributionLoadLink',
    'lgDistributionPenetrationLevel',
  ],
  'REIT Comps': [
    'reitName',
    'reitPropertyAddress',
    'reitCity',
    'reitState',
    'reitZip',
    'reitSize',
    'reitYearBuilt',
    'reitLastSalePrice',
    'reitLastSaleDate',
    'reitClass',
    'reitOwnershipPercentage',
    'reitAssetManager',
    'reitAmPhone',
    'reitRegionalVp',
    'reitRvpPhone',
    'purchaseValue',
    'propertyType',
    'region',
  ],
  /** --- CALIFORNIA HSR --- */
  'California HSR Alignment': [
    'cons_status',
    'cons_proj_name',
    'projectPageURL',
    'issueDate',
    'startDate',
    'endDate',
    'active',
    'stat_name',
    'xStreets',
    'phase',
    'section',
  ],
  /** --- Lightbox Zoning Boundaries --- */
  'Lightbox Zoning Boundaries': [
    'lzbStateAbv',
    'lzbType',
    'lzbCode',
    'lzbCategory',
    'lzbSubcategory',
    'lzbDescription',
  ],
  /** --- Lightbox Parcels --- */
  'Lightbox Parcels': [
    'lpParcelId',
    'lpTaxId',
    'lpAddress',
    'lpCounty',
    'lpMunicipality',
    'lpOwner',
    'lpOwnerAddress',
    'lpOwnerType',
    'lpMarketLandValue',
    'lpMarketBuildingValue',
    'lpMarketTotalValue',
    'lpLandUseCode',
    'lpPropertyType',
    'lpMailAddress',
    'lpAcreageAssessed',
    'lpAcreageCalculated',
    'lpLotCount',
    'lpZoning',
  ],
  /** --- Lightbox Parcel Zoning --- */
  'Lightbox Parcel Zoning': [
    'lpzJurisdiction',
    'lpzJurisdictionType',
    'lpzZoningType',
    'lpzZoningCode',
    'lpzZoningCategory',
    'lpzZoningSubcategory',
    'lpzZoningDescription',
    'lpzDocumentLink',
    'lpzMinLotArea',
    'lpzMaxBuildingHeight',
    'lpzZoningSummary',
    'lpzPermittedUses',
  ],
  /** --- State Plane Zones --- */
  'State Plane Zones': [
    'spzZone',
    'spzZoneType',
    'spzFipsZone',
    'spzSqmiles',
    'spzCode',
  ],
  /** --- Opportunity Zones --- */
  'Future Opportunity Zones': [
    'ruralStat',
    'tractName',
    'metroName',
  ],
  /** --- Future Land Use --- */
  'Future Land Use': [
    'county',
  ],
  /** --- FedEx Locations --- */
  'FedEx Locations': [
    'fedexAddress',
    'fedexCity',
    'fedexState',
    'fedexTenantName',
    'fedexBuildingSize',
    'fedexMovedIn',
    'fedexCommencementDate',
    'fedexOccupancy',
    'fedexMarket',
    'fedexSubmarket',
    'fedexLandlord',
  ],
  /** --- School District Boundaries --- */
  'School District Boundaries': [
    'sdName',
    'sdGeoid',
    'sdType',
    'sdStateFips',
    'sdLowestGrade',
    'sdHighestGrade',
    'sdSchoolYear',
    'sdLandArea',
    'sdWaterArea',
    'sdElsdLea',
    'sdScsdLea',
    'sdUnsdLea',
    'sdLsad',
    'sdFuncStat',
    'sdGeoYear',
  ],
  /** --- Transmission Network Diagram --- */
  'Transmission Network Diagram': [
    'otnBranchId',
    'otnDescription',
    'otnIso',
    'otnFromBusId',
    'otnFromBusName',
    'otnToBusId',
    'otnToBusName',
    'otnVoltage',
    'otnCircuitId',
    'otnScenario',
    'otnCapacity0Upgrades',
    'otnCapacity1Upgrades',
    'otnCapacity2Upgrades',
    'otnCapacity3Upgrades',
    'otnCapacity4Upgrades',
    'otnBranchRating1',
    'otnBranchRating2',
    'otnPrimaryLimitingConstraint',
    'otnDescriptivePowerflowCase',
  ],
  /** --- Orennia Substations --- */
  'Orennia Substations': [
    'osOwner',
    'osSubstationId',
    'osNameSource',
    'osCounty',
    'osState',
    'osStatus',
    'osType',
    'osMaxVoltage',
    'osMinVoltage',
  ],
  /** --- Exit Cap Rate Layer --- */
  'Exit Cap Rate': [
    'market',
    'low',
    'mid',
    'high',
  ],
  /** --- Orennia Buses --- */
  'Orennia Buses': [
    'obBusId',
    'obBusVoltage',
    'obOwner',
    'obUpgradeCapacity0',
    'obUpgradeCapacity1',
    'obUpgradeCapacity2',
    'obUpgradeCapacity3',
    'obUpgradeCapacity4',
    'oicScenario',
    'oicSensitivityCase',
    'oicBusId',
    'oicInterconnectionType',
    'oicProxyInterconnectionCapacity',
    'oicTotalUpgradeCost',
    'oicNumberOfUpgrades',
    'oicUpgradeIndex',
    'oicDfaxAc',
    'oicViolatedConstraint',
    'oicViolatedConstraintBranchId',
    'oicContingency',
    'oicConstraintType',
    'oicConstraintRating',
    'oicConstraintLength',
    'oicLengthSource',
    'oicConstraintKvs',
    'oicAcLoadingRatioPercentage',
    'oicExistingOverloadFlag',
    'oicRiskLevel',
    'oicMaxLeadTime',
    'oicMinLeadTime',
    'oicDfaxCutoffRatio',
    'oicBeforeInterconnectionFlow',
    'oicFlowContribution',
    'oicPostInterconnectionFlow',
    'oicUpgradeType',
    'oicUpgradeRating',
    'oicUpgradeUnitCost',
    'oicAchievableRating',
    'oicIndividualUpgradeCost',
    'oicPowerflowCase',
    'oicDescriptivePowerflowCase',
    'oicStudyYear',
    'oicGeneratorModelingAssumptions',
    'oicTransmissionModelingAssumptions',
    'oicCaseLastUpdated',
  ],
  'Orennia Power Plants': [
    'oppType',
    'oppCapacity',
    'oppGeneratorName',
    'oppOwner',
    'oppStatus',
    'oppAvgHeatRate',
    'oppCapex',
    'oppCapexPerWatt',
  ],
  'Data Center Comps': [
    'dccPlantID',
    'dccParentName',
    'dccOwnerName',
    'dccCapacity',
    'dccSquareFootage',
    'dccStatus',
    'dccISORegion',
    'dccProjectCount',
    'dccConstructionDuration',
    'dccTIVCounts',
    'dccType',
    'dccStage',
    'dccKickoff',
    'dccCompletionDate',
    'dccHyperscaler',
  ],
};
